module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_vm._v("3.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("Days passed. I looked at my e-mail, at my regular mail, but not with any hope. I often wrote to her, and she almost never responded: this was her habit. She preferred the telephone or long nights of talk when I went to Naples.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("I opened my drawers, the metal boxes where I keep all kinds of things. Not much there. I’ve thrown away a lot of stuff, especially anything that had to do with her, and she knows it. I discovered that I have nothing of hers, not a picture, not a note, not a little gift. I was surprised myself. Is it possible that in all those years she left me nothing of herself, or, worse, that I didn’t want to keep anything of her? It is.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("This time I telephoned Rino; I did it unwillingly. He didn’t answer on the house phone or on his cell phone. He called me in the evening, when it was convenient. He spoke in the tone of voice he uses to arouse pity.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“I saw that you called. Do you have any news?”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“No. Do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("He rambled incoherently. He wanted to go on TV, on the show that looks for missing persons, make an appeal, ask his mamma’s forgiveness for everything, beg her to return.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("I listened patiently, then asked him: “Did you look in her closet?”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“What for?”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("Naturally the most obvious thing would never occur to him.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Go and look.”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("He went, and he realized that there was nothing there, not one of his mother’s dresses, summer or winter, only old hangers. I sent him to search the whole house. Her shoes were gone. The few books: gone. All the photographs: gone. The movies: gone. Her computer had disappeared, including the old-fashioned diskettes and everything, everything to do with her experience as an electronics wizard who had begun to operate computers in the late sixties, in the days of punch cards. Rino was astonished. I said to him:")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Take as much time as you want, but then call and tell me if you’ve found even a single hairpin that belongs to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("He called the next day, greatly agitated.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“There’s nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Nothing at all?”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“No. She cut herself out of all the photographs of the two of us, even those from when I was little.”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“You looked carefully?”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Everywhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Even in the cellar?”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“I told you, everywhere. And the box with her papers is gone: I don’t know, old birth certificates, telephone bills, receipts. What does it mean? Did someone steal everything? What are they looking for? What do they want from my mother and me?”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("I reassured him, I told him to calm down. It was unlikely that anyone wanted anything, especially from him.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Can I come and stay with you for a while?”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“Please, I can’t sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("“That’s your problem, Rino, I don’t know what to do about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("I hung up and when he called back I didn’t answer. I sat down at my desk.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("Lila is overdoing it as usual, I thought.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("She was expanding the concept of trace out of all proportion. She wanted not only to disappear herself, now, at the age of sixty-six, but also to eliminate the entire life that she had left behind.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("I was really angry.")]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_vm._v("We’ll see who wins this time, I said to myself. I turned on the computer and began to write—all the details of our story, everything that still remained in my memory.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-663d1c90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/neapolitan-novels-boxed-set_00006.vue
// module id = 84
// module chunks = 0